import { AuthTokenInfoType } from '@gql/graphql';
import { MtSocialProviderType } from '@presentation/components';

export const PROVIDER_TYPE_TO_FRONTEND_TYPE: Record<AuthTokenInfoType, MtSocialProviderType> = {
  facebook: MtSocialProviderType.FACEBOOK,
  google: MtSocialProviderType.GOOGLE,
  firebase: MtSocialProviderType.FIREBASE,
};

export const FRONTEND_TYPE_TO_PROVIDER_TYPE: Record<MtSocialProviderType, AuthTokenInfoType> = {
  FACEBOOK: AuthTokenInfoType.facebook,
  GOOGLE: AuthTokenInfoType.google,
  FIREBASE: AuthTokenInfoType.firebase,
};
